// src/encounter/archive-bundle-confirm-dialog.tsx
// Confirmation before archiving a saved A/P bundle (PROD-2697). PRESENTATIONAL — composes the DS
// `ModalYesNo`, the same shape as patients/components/archive-confirm-dialog.tsx.
//
// Copy is verbatim from PROD-2697. This is still the "Bundles" surface; the rename to "Order sets"
// belongs to PROD-2673, so do not rename it here.
import { ModalYesNo } from '@scripsteam/scrips-signal-ds';
import type { ApBundle } from './services/use-bundles';

export const ARCHIVE_BUNDLE_TITLE = 'Archive bundle?';

/** The body names the bundle the same way the DS row does (blank name → "Untitled bundle"). */
function archiveBundleMessage(bundle: ApBundle): string {
  const name = bundle.bundleName?.trim() || 'Untitled bundle';
  return `"${name}" will be removed from your bundles list.`;
}

export interface ArchiveBundleConfirmDialogProps {
  /** The bundle awaiting confirmation; null → closed. */
  bundle: ApBundle | null;
  onConfirm: (bundle: ApBundle) => void;
  onCancel: () => void;
}

export function ArchiveBundleConfirmDialog({
  bundle,
  onConfirm,
  onCancel,
}: ArchiveBundleConfirmDialogProps) {
  if (!bundle) return null;
  return (
    <ModalYesNo
      open
      onCancel={onCancel}
      title={ARCHIVE_BUNDLE_TITLE}
      message={archiveBundleMessage(bundle)}
      cancelLabel="Cancel"
      confirmLabel="Archive"
      onConfirm={() => onConfirm(bundle)}
      destructive
    />
  );
}
